import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    n: "01",
    title: "Aanmelding",
    body: [
      "Door je aan te melden voor een cursus van Pattern Texture Academy ga je akkoord met deze algemene voorwaarden.",
      "Een plek in een cursus wordt pas gereserveerd zodra de betaling of overeengekomen aanbetaling is ontvangen.",
    ],
  },
  {
    n: "02",
    title: "Betalingen",
    body: [
      "Alle cursusgelden moeten worden betaald volgens de gekozen betaaloptie.",
      "Bij een betalingsregeling blijven alle geplande betalingen verschuldigd totdat het volledige cursusbedrag is voldaan.",
      "Bij niet-nakomen van betalingen kan deelname aan de cursus worden geweigerd.",
    ],
  },
  {
    n: "03",
    title: "Geen restitutie",
    body: [
      "Alle betalingen zijn niet-restitueerbaar.",
      "Zodra een deelnemer zich heeft aangemeld en betaald, wordt onder geen enkele omstandigheid restitutie verleend, inclusief maar niet beperkt tot:",
    ],
    list: [
      "Van gedachten veranderen",
      "Persoonlijke omstandigheden",
      "Agenda-conflicten",
      "Niet komen opdagen",
      "Reisproblemen",
    ],
  },
  {
    n: "04",
    title: "Annuleringen",
    body: [
      "Als een deelnemer niet aanwezig kan zijn, moet dit zo snel mogelijk aan Pattern Texture Academy worden doorgegeven.",
      "Het verzetten naar een andere cursusdatum is niet gegarandeerd en blijft de discretie van Pattern Texture Academy.",
    ],
  },
  {
    n: "05",
    title: "Wijzigingen in de cursus",
    body: [
      "Pattern Texture Academy behoudt zich het recht voor om cursusdata, tijden, instructeurs of locaties indien nodig te wijzigen.",
      "Deelnemers worden op de hoogte gebracht van belangrijke wijzigingen.",
    ],
  },
  {
    n: "06",
    title: "Aanwezigheid",
    body: [
      "Deelnemers zijn zelf verantwoordelijk voor het op tijd komen en het bijwonen van alle cursusdagen.",
      "Gemiste lessen komen niet in aanmerking voor restitutie, krediet of inhaallessen, tenzij schriftelijk anders overeengekomen.",
    ],
  },
  {
    n: "07",
    title: "Cursusmateriaal",
    body: [
      "Al het cursusmateriaal, technieken, methodes, documenten en lesinhoud blijven intellectueel eigendom van Pattern Texture Academy.",
      "Deelnemers mogen de cursusinhoud niet kopiëren, reproduceren, distribueren, doorgeven aan derden, verkopen of delen zonder schriftelijke toestemming.",
    ],
  },
  {
    n: "08",
    title: "Foto's & video's",
    body: [
      "Pattern Texture Academy kan tijdens cursusdagen foto's en video's maken voor educatieve en promotionele doeleinden.",
      "Deelnemers die niet op foto's of video's willen verschijnen moeten dit schriftelijk doorgeven aan Pattern Texture Academy vóór aanvang van de cursus.",
    ],
  },
  {
    n: "09",
    title: "Aansprakelijkheid",
    body: [
      "Deelname aan de cursus is op eigen risico.",
      "Pattern Texture Academy is niet aansprakelijk voor persoonlijk letsel, verlies, diefstal, schade aan persoonlijke eigendommen of indirecte schade voortvloeiend uit deelname aan de cursus.",
    ],
  },
  {
    n: "10",
    title: "Eten, allergieën & dieetwensen",
    body: [
      "Deelnemers zijn zelf verantwoordelijk voor het doorgeven van allergieën of dieetwensen tijdens de aanmelding.",
      "Pattern Texture Academy doet zijn best om dieetwensen tegemoet te komen, maar kan geen allergeen-vrije omgeving garanderen.",
    ],
  },
  {
    n: "11",
    title: "Contact",
    body: [
      "Voor vragen over aanmelding, betalingen of cursussen kunnen deelnemers Pattern Texture Academy bereiken via de contactgegevens op de website.",
    ],
  },
  {
    n: "12",
    title: "Akkoord",
    body: [
      "Door het versturen van een aanmelding en het voltooien van de betaling bevestigt de deelnemer deze Algemene Voorwaarden te hebben gelezen, begrepen en geaccepteerd.",
    ],
  },
];

export default function Terms() {
  return (
    <Layout>
      <Link
        to="/"
        className="flex items-center gap-2 label-tag mb-6 mt-2 hover:opacity-70"
        data-testid="terms-back"
      >
        <ArrowLeft size={14} /> Terug naar website
      </Link>

      <div className="label-tag mb-3">— Juridisch</div>
      <h1 className="font-display text-5xl sm:text-7xl leading-[0.95] tracking-tight" data-testid="terms-title">
        Algemene<br /><span className="italic">Voorwaarden</span>
      </h1>
      <p className="mt-5 text-base sm:text-lg leading-snug text-black/85 font-medium max-w-xl">
        Pattern Texture Academy. Lees deze voorwaarden goed door — door je aan te melden ga je hiermee akkoord.
      </p>

      <div className="mt-10 space-y-7" data-testid="terms-content">
        {SECTIONS.map((s) => (
          <section key={s.n} className="glass-block">
            <div className="flex items-baseline gap-4">
              <span className="font-display text-3xl text-[#FF6A1A]/80 leading-none">{s.n}</span>
              <h2 className="font-display text-2xl sm:text-3xl text-[#FF6A1A] leading-tight">
                {s.title}
              </h2>
            </div>
            <div className="mt-4 space-y-3 text-[#FF6A1A]/95 text-sm sm:text-base font-medium leading-relaxed">
              {s.body.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              {s.list && (
                <ul className="mt-2 space-y-1.5">
                  {s.list.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <span className="text-[#FF6A1A]/60 mt-1">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-10 label-tag opacity-70" data-testid="terms-effective">
        Laatst bijgewerkt: februari 2026
      </div>
    </Layout>
  );
}
